/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestEventDto } from '../../models/harvest-event-dto';

export interface GetEvents$Params {
  harvestId: number;
}

export function getEvents(http: HttpClient, rootUrl: string, params: GetEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestEventDto>>> {
  const rb = new RequestBuilder(rootUrl, getEvents.PATH, 'get');
  if (params) {
    rb.path('harvestId', params.harvestId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HarvestEventDto>>;
    })
  );
}

getEvents.PATH = '/api/harvests/{harvestId}/events';
